import "./index.scss";
import CustomModal from "../../components/common/modal";
import Button from "../../components/common/button";
import api from "../../utils/interface";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { signIn } from "../../utils/router/constant";
import { resetIsFirstTimeState } from "../../store/slices/commonSlice";
import { handleConditionalRedirect } from "../../utils/helper";

function Logout({ handleLogoutClick, show }) {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const customerData = useSelector((state) => state.common.customerData);
  const logout = async () => {
    try {
      await api.post(`/v1/logoutApi`);
      localStorage.clear();
      localStorage.removeItem("token");
      localStorage.removeItem("redirectTo");
      toast.success("Successfully Logged Out");
      dispatch(resetIsFirstTimeState());
      // if (customerData?.return_url) {
      //   window.location.href = `${customerData?.return_url}${signIn}`;
      // } else {
      //   nav(signIn);
      // }
      handleConditionalRedirect(customerData?.return_url, signIn, nav);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };
  return (
    <>
      <CustomModal
        show={show}
        handleClose={handleLogoutClick}
        title={"Confirm Logout"}
      >
        <div className="logout-modal-body">
          Are you sure you want to log out?
        </div>
        <div className="logout-modal-footer">
          <Button
            variant="secondary"
            onClick={handleLogoutClick}
            label="Cancel"
          />
          <Button variant="primary" onClick={logout} label="Logout" />
        </div>
      </CustomModal>
    </>
  );
}

export default Logout;
